import React from 'react';
import { Currency } from 'ui-toolkit';
import { ExpectedBorrowerMoneyLabel } from '../../escrow/escrowHeader/ExpectedBorrowerMoneyLabel';
import { ExpectedBuyerMoneyLabel } from '../../escrow/escrowHeader/ExpectedBuyerMoneyLabel';
import { ExpectedLenderMoneyLabel } from '../../escrow/escrowHeader/ExpectedLenderMoneyLabel';
import { CardTW } from '../../../../tailwindComponents/CardTW/CardTW';
import { HeaderText3TW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { StyledCardDivTW, StyledCardTextTW } from './feesOverviewCardsStylesTW';
import { ExpectedSellerMoneyLabel } from '../../escrow/escrowHeader/ExpectedSellerMoneyLabel';
import classNames from 'classnames';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';

export interface IExpectedCard {
  borrowerMoney: number | null;
  buyerMoney: number | null;
  lenderMoney: number | null;
  loanAmount: number | null;
  sellerMoney: number | null;
  transactionType: eTransactionCategory;
}

export const ExpectedCard: React.FC<IExpectedCard> = ({
  borrowerMoney,
  buyerMoney,
  lenderMoney,
  loanAmount,
  sellerMoney,
  transactionType,
}) => {
  return (
    <CardTW
      className={classNames(
        transactionType === eTransactionCategory.Refinance ? 'shrink-0 grow-0 basis-96' : 'basis-4/12'
      )}
      contentClassName={'p-0'}
    >
      <HeaderText3TW className={'p-4 pb-0'}>Expected Money</HeaderText3TW>
      <div className={'flex flex-row'}>
        {transactionType === eTransactionCategory.Refinance && (
          <StyledCardDivTW className={'grow basis-1/3'}>
            <ExpectedBorrowerMoneyLabel />
            <StyledCardTextTW data-test-id={'borrower-money'}>
              {borrowerMoney && borrowerMoney < 0 ? <Currency value={borrowerMoney * -1} /> : '--'}
            </StyledCardTextTW>
          </StyledCardDivTW>
        )}
        {transactionType === eTransactionCategory.Purchase && (
          <>
            <StyledCardDivTW className={'grow basis-1/3'}>
              <ExpectedBuyerMoneyLabel />
              <StyledCardTextTW data-test-id={'buyer-money'}>
                {buyerMoney && buyerMoney > 0 ? <Currency value={buyerMoney} /> : '--'}
              </StyledCardTextTW>
            </StyledCardDivTW>
            <StyledCardDivTW className={'grow basis-1/3'}>
              <ExpectedSellerMoneyLabel />
              <StyledCardTextTW data-test-id={'seller-money'}>
                {sellerMoney && sellerMoney > 0 ? <Currency value={sellerMoney} /> : '--'}
              </StyledCardTextTW>
            </StyledCardDivTW>
          </>
        )}
        <StyledCardDivTW className={'grow basis-1/3'}>
          <ExpectedLenderMoneyLabel />
          <StyledCardTextTW data-test-id={'lender-money'}>
            {loanAmount !== null && loanAmount > 0 ? <Currency value={lenderMoney} /> : '--'}
          </StyledCardTextTW>
        </StyledCardDivTW>
      </div>
    </CardTW>
  );
};
